import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { translate } from "../../Services/translation";
const DecalTemplates = ({ decalTemplates, onTemplateClick }) => {
    if (!decalTemplates || decalTemplates.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: "cart-images-container", children: [_jsx("h4", { className: "section-title", children: translate('decal.templates.header') }), _jsx("div", { className: "template-selector-grid", children: decalTemplates.map((template, index) => (_jsx("div", { className: "template-selector-card", children: _jsx("img", { src: template.imagePreview, alt: template.templateName || `Template ${index + 1}`, onClick: () => onTemplateClick(template) }) }, index))) })] }));
};
export default DecalTemplates;
